import { render, staticRenderFns } from "./AddComplaintTypeModal.vue?vue&type=template&id=b2caba14&scoped=true"
import script from "./AddComplaintTypeModal.vue?vue&type=script&lang=js"
export * from "./AddComplaintTypeModal.vue?vue&type=script&lang=js"
import style0 from "./AddComplaintTypeModal.vue?vue&type=style&index=0&id=b2caba14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2caba14",
  null
  
)

export default component.exports